import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { Grid2, Paper } from "@mui/material";
import { GridApi } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { customThemeWithHeaders } from "../../manager/components/table/AdjustmentsManagerTable";
import { useTableData } from "../hooks/useTableData";
import { MillAdjustment } from "../models/MillAdjustment";

type Props = {
	rows: MillAdjustment[];
	loading: boolean;
	onGridReady: (api: GridApi) => void;
	onRowSelected?: (row: MillAdjustment) => void;
};

export const AdjustmentsReportTable = ({
	rows,
	loading,
	onGridReady,
	onRowSelected,
}: Props) => {
	const [error, setError] = useState("");

	const { columnDefs } = useTableData();
	const { defaultColDef } = useGridDefinitions({});

	const handleGridReady = (params: any) => {
		onGridReady(params.api);
	};

	const handleRowClicked = (event: any) => {
		if (onRowSelected) {
			onRowSelected(event.data);
		}
	};

	return (
		<>
			<HelmetDexteel title="Adjustments Report" />
			<div onContextMenu={(e) => e.preventDefault()}>
				<Grid2 container>
					<Grid2
						size={{ md: 12, xs: 12 }}
						style={{
							padding: 10,
							height: "77vh",
							minHeight: "77vh",
							margin: "10px 0",
						}}
						component={Paper}
						elevation={2}
					>
						<AgGridReact<MillAdjustment>
							loading={loading}
							rowData={rows}
							columnDefs={columnDefs}
							defaultColDef={defaultColDef}
							animateRows
							rowHeight={38}
							headerHeight={35}
							tooltipShowDelay={0}
							tooltipHideDelay={2000}
							onGridReady={handleGridReady}
							onRowClicked={handleRowClicked}
							loadingOverlayComponent={CenteredLazyLoading}
							suppressContextMenu={true}
							gridOptions={{
								rowSelection: {
									mode: "singleRow",
									checkboxes: false,
									enableClickSelection: true,
								},
								theme: customThemeWithHeaders,
							}}
						/>
					</Grid2>
				</Grid2>
				<ErrorModal error={error} onHide={() => setError("")} />
			</div>
		</>
	);
};
